var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L15.657 15.657M15.657 15.657C16.3999 14.9142 16.9892 14.0322 17.3913 13.0616C17.7933 12.091 18.0002 11.0507 18.0002 10.0001C18.0002 8.94952 17.7933 7.90922 17.3913 6.9386C16.9892 5.96798 16.3999 5.08606 15.657 4.34318C14.9142 3.6003 14.0322 3.01102 13.0616 2.60897C12.091 2.20693 11.0507 2 10.0001 2C8.94952 2 7.90922 2.20693 6.9386 2.60897C5.96798 3.01102 5.08606 3.6003 4.34318 4.34318C2.84287 5.84349 2 7.87835 2 10.0001C2 12.1219 2.84287 14.1567 4.34318 15.657C5.84349 17.1574 7.87835 18.0002 10.0001 18.0002C12.1219 18.0002 14.1567 17.1574 15.657 15.657Z",
    stroke: "#434343",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.02ffa483c1c6d689205a61c1016cffb1.svg";
export { ForwardRef as ReactComponent };